module.exports = __webpack_public_path__ + "img/labmem_text_btnfinish_sc.109865b7.png";